import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enHome from './locales/en/home.json';
import enProfile from './locales/en/profile.json';
import enDashboard from './locales/en/dashboard.json';
import enRecruiter from './locales/en/recruiter.json';
import enValidation from './locales/en/validation.json';
import enErrors from './locales/en/errors.json';
import enJobOffers from './locales/en/jobOffers.json';
import enLegal from './locales/en/legal.json';
import enAIMatching from './locales/en/aiMatching.json';

import frCommon from './locales/fr/common.json';
import frAuth from './locales/fr/auth.json';
import frHome from './locales/fr/home.json';
import frProfile from './locales/fr/profile.json';
import frDashboard from './locales/fr/dashboard.json';
import frRecruiter from './locales/fr/recruiter.json';
import frValidation from './locales/fr/validation.json';
import frErrors from './locales/fr/errors.json';
import frJobOffers from './locales/fr/jobOffers.json';
import frLegal from './locales/fr/legal.json';
import frAIMatching from './locales/fr/aiMatching.json';

import arCommon from './locales/ar/common.json';
import arAuth from './locales/ar/auth.json';
import arHome from './locales/ar/home.json';
import arProfile from './locales/ar/profile.json';
import arDashboard from './locales/ar/dashboard.json';
import arRecruiter from './locales/ar/recruiter.json';
import arValidation from './locales/ar/validation.json';
import arErrors from './locales/ar/errors.json';
import arJobOffers from './locales/ar/jobOffers.json';
import arLegal from './locales/ar/legal.json';
import arAIMatching from './locales/ar/aiMatching.json';

// Define resources
const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    home: enHome,
    profile: enProfile,
    dashboard: enDashboard,
    recruiter: enRecruiter,
    validation: enValidation,
    errors: enErrors,
    jobOffers: enJobOffers,
    legal: enLegal,
    aiMatching: enAIMatching,
  },
  fr: {
    common: frCommon,
    auth: frAuth,
    home: frHome,
    profile: frProfile,
    dashboard: frDashboard,
    recruiter: frRecruiter,
    validation: frValidation,
    errors: frErrors,
    jobOffers: frJobOffers,
    legal: frLegal,
    aiMatching: frAIMatching,
  },
  ar: {
    common: arCommon,
    auth: arAuth,
    home: arHome,
    profile: arProfile,
    dashboard: arDashboard,
    recruiter: arRecruiter,
    validation: arValidation,
    errors: arErrors,
    jobOffers: arJobOffers,
    legal: arLegal,
    aiMatching: arAIMatching,
  },
};

// Initialize i18next
const initI18n = () => {
  // Get initial language from localStorage safely
  const savedLanguage = typeof window !== 'undefined'
    ? localStorage.getItem('language')
    : null;

  i18n
    .use(LanguageDetector) // Detect user language
    .use(initReactI18next) // Pass i18n instance to react-i18next
    .init({
      resources,
      fallbackLng: 'en', // Fallback language
      defaultNS: 'common', // Default namespace
      ns: ['common', 'auth', 'home', 'profile', 'dashboard', 'recruiter', 'validation', 'errors', 'jobOffers', 'legal', 'aiMatching'],
      lng: savedLanguage || 'en', // Set initial language from localStorage or default to 'en'

      detection: {
        // Order of detection
        order: ['localStorage', 'navigator'],
        // Cache user language
        caches: ['localStorage'],
        lookupLocalStorage: 'language',
      },

      interpolation: {
        escapeValue: false, // React already escapes values
      },

      react: {
        useSuspense: false, // Disable suspense
      },

      // Load resources synchronously
      load: 'languageOnly',

      // Don't load resources asynchronously
      partialBundledLanguages: false,
    });

  return i18n;
};

// Initialize immediately
initI18n();

export default i18n;
